import { toGO } from '../navBar'

const ProModeSection = () => {
  const features = [
    {
      title: 'USDC pairs with up to 0.05% fees',
      description: 'USDC pairs at the lowest fees available, with many more to be added soon.'
    },
    {
      title: 'Professional-grade interface',
      description: 'Keyboard navigation, resizable modules, and chart-integrated order editing.'
    },
    {
      title: 'Built by traders',
      description: 'Built on continuous input from traders, evolving to serve you better.'
    }
  ]

  return (
    <div className='relative bg-black mt-20 text-white min-h-screen py-20'>
      <div
        className='absolute top-0 left-0 right-0 h-2'
        style={{
          background: 'linear-gradient(90deg, #000, #9a9a9a)'
        }}
      />
      <div className='w-full px-4'>
        {/* Header */}
        <div className='text-center mb-16'>
          <h2 className='text-5xl font-bold mb-4'>Pro Mode</h2>
          <p className='text-gray-400 text-lg'>Our web interface for professional-grade trading.</p>
        </div>

        {/* Main Image */}
        <div className='mb-16 relative'>
          <img
            src='https://telegraph-image-9jg.pages.dev/file/AgACAgEAAyEGAASNsUhIAAMuZ4S_ASel__ys-p3EzrleSTXtp7cAAiCxMRtRwSFEH_4KcrMDdS0BAAMCAAN3AAM2BA.png'
            alt='Pro Trading Interface'
            className='w-full rounded-lg shadow-2xl'
          />
          <div className='absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-lg'></div>
        </div>

        {/* Features Grid */}
        <div className='grid grid-cols-1 md:grid-cols-3 gap-12 md:gap-8 mb-12 md:mb-16 max-w-6xl mx-auto'>
          {features.map((feature, index) => (
            <div key={index} className='text-center space-y-3'>
              <h3 className='text-2xl md:text-xl font-semibold'>{feature.title}</h3>
              <p className='text-gray-400 text-lg md:text-base'>{feature.description}</p>
            </div>
          ))}
        </div>

        {/* CTA Buttons */}
        <div className='flex flex-col md:flex-row justify-center gap-4 max-w-xs mx-auto md:max-w-none'>
          <button
            onClick={toGO}
            className='w-full md:w-auto bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-medium transition-colors'>
            Start trading
          </button>
          <button
            onClick={toGO}
            className='w-full md:w-auto bg-transparent border border-gray-700 hover:border-gray-500 text-white px-6 py-3 rounded-lg font-medium transition-colors'>
            Learn more
          </button>
        </div>
      </div>
      <div
        className='absolute bottom-0 left-0 right-0 h-2'
        style={{
          background: 'linear-gradient(90deg, #000, #9a9a9a)'
        }}
      />
    </div>
  )
}

export default ProModeSection
